<template>
  <div v-if="isToggle" class="absolute left-0 right-0 top-0 bottom-0 z-60">
    <desktop-slide-show v-if="$mq.md" :dimension-icon="dimensionIcon"></desktop-slide-show>

    <mobile-slide-show v-else :dimension-icon="dimensionIcon"></mobile-slide-show>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DesktopSlideShow from "./DesktopSlideShow.vue";
import MobileSlideShow from "./MobileSlideShow.vue";

export default {
  name: "ArtworkSlideShow",
  components: {MobileSlideShow, DesktopSlideShow},
  data () {
    return {
      artworks: {},
      toggled: false,
    }
  },

  props: {
    dimensionIcon: {
      required: true,
    }
  },

  computed: {
    ...mapState({
      isToggle: state => state.slideShow.isToggle,
    }),
  },
}
</script>
